
import { IQuestionObj } from "../../../interfaces/quiz";
import enQuestions from "./en";
import spQuestions from "./sp";
import frQuestions from "./fr";
import ptQuestions from "./pt";

const questions:IQuestionObj ={
    pt:ptQuestions,
    fr:frQuestions,
    en:enQuestions,
    sp:spQuestions
};
export default questions;